<template>
  <div v-if="!isLoading && contactPerson" class="memorial-form__rsvp-contact">
    <h3 v-text="texts.contactAdvisorHeading" />
    <ix-img
      v-if="contactPerson.profile_image"
      :alt="contactPerson.name"
      :src="contactPerson.profile_image"
      width="100"
      height="100"
      :imgix-params="{ fit: 'crop', crop: 'faces', w: 100, h: 100 }"
    />
    <div>
      <p class="name">
        {{ contactPerson.name }}
      </p>
      <p v-if="contactPerson.tel" class="phone" v-text="contactPerson.tel" />
      <p v-if="email" class="email">
        <a :href="`mailto:${email}`" v-text="email" />
      </p>
    </div>
  </div>
  <div v-else-if="!contactPerson" />
  <div v-else class="memorial-form__funeral-advisor">
    <div class="skeleton-loader" style="height: 4em" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'FuneralAdvisor',

  data() {
    const { dataset } = this.$mountEl;

    return {
      id: dataset.orderId,
      advisorHandlesRsvp: dataset.advisorHandlesRsvp,
      texts: lavendlaObituary.rsvp,
    };
  },

  computed: {
    ...mapState('orders', ['order', 'isLoading']),

    contactPerson() {
      return this.advisorHandlesRsvp ? this.order?.user : this.order?.customer;
    },

    email() {
      if (!this.contactPerson?.email) {
        return null;
      }

      return this.contactPerson.email.split(',')[0];
    },
  },

  created() {
    if (this.id && !this.order) {
      this.$store.dispatch('orders/getOrder', this.id);
    }
  },
};
</script>
